import { render, staticRenderFns } from "./NewsContent.vue?vue&type=template&id=635ad602&scoped=true&"
import script from "./NewsContent.vue?vue&type=script&lang=js&"
export * from "./NewsContent.vue?vue&type=script&lang=js&"
import style0 from "./NewsContent.vue?vue&type=style&index=0&id=635ad602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ad602",
  null
  
)

export default component.exports